'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extend = exports.create = exports.createFactory = undefined;

var _createFactory2 = require('./create-factory');

var _createFactory3 = _interopRequireDefault(_createFactory2);

var _create2 = require('./create');

var _create3 = _interopRequireDefault(_create2);

var _extend2 = require('./extend');

var _extend3 = _interopRequireDefault(_extend2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.createFactory = _createFactory3['default'];
exports.create = _create3['default'];
exports.extend = _extend3['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/class/index.js
 ** module id = 504
 ** module chunks = 0 1
 **/